import { z } from 'zod'

import { useNav, useParseQuery } from '../../../hooks/useNav'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { PATH } from '../../../data/router_path'
import HeaderLayout from '../../../layouts/Header'
import SearchHeader from '../../../components/function/filters/SearchHeader'
import Select from '../../../components/function/filters/Select'
import Date from '../../../components/function/filters/Date'
import DropDownList from '../../../components/function/filters/DropDownList'
import { Button } from '../../../components/ui/legacy'
import {
  addDefaultDropDown,
  convertFilterDateFormat,
  convertFilterDateFixed,
} from '../../../utils/conversion'
import { showErrorToast } from '../../../utils/showToast'
import useGetAccountGroup from './hooks/useGetAccountGroup'
import { useEffect } from 'react'

const accountFilterSchema = z.object({
  keywords: z.string().nullable().optional(),
  all_radio: z.boolean().nullable().optional(),
  date_fixed_radio: z.boolean().nullable().optional(),
  date_fixed: z.string().nullable().optional(),
  date_range_radio: z.boolean().nullable().optional(),
  date_from: z.string().nullable().optional(),
  date_to: z.string().nullable().optional(),
  group: z.string().optional().nullable(),
})
export default function AccountFilterHeader() {
  const navigate = useNav()
  const { queryParams } = useParseQuery()
  const { control, handleSubmit, setValue, watch } = useForm({
    resolver: zodResolver(accountFilterSchema),
    defaultValues: {
      keywords: '',
      all_radio: true,
      date_fixed_radio: false,
      date_fixed: undefined,
      date_range_radio: false,
      date_from: undefined,
      date_to: undefined,
      group: '',
    },
  })
  const [all_radio, group] = watch(['all_radio', 'group'])

  const searchHandler = (formValue) => {
    const {
      all_radio,
      date_fixed_radio,
      date_range_radio,
      keywords,
      date_fixed,
      date_from,
      date_to,
      group,
    } = formValue
    let filters = { ...queryParams, keywords, group, pageNumber: 0 }
    if (all_radio) {
      filters.joinDate = undefined
    }
    if (date_fixed_radio) {
      if (!date_fixed) {
        showErrorToast({
          message: 'Vui lòng chọn ngày cụ thể',
        })
        return
      }
      filters.joinDate = `${convertFilterDateFixed(date_fixed)}`
    } else if (date_range_radio) {
      if (!date_from || !date_to) {
        showErrorToast({
          message: 'Vui lòng chọn đủ khoảng ngày',
        })
        return
      }
      filters.joinDate = `${convertFilterDateFormat(date_from)}-${convertFilterDateFormat(date_to)}`
    }

    navigate(PATH.ACCOUNT.LIST, { params: filters })
  }
  useEffect(() => {
    handleSubmit(searchHandler)()
  }, [group])

  useEffect(() => {
    if (all_radio) {
      handleSubmit(searchHandler)()
    }
  }, [all_radio])
  const handleRadioChange = (selectedName, newValue) => {
    if (newValue) {
      setValue('all_radio', selectedName === 'all_radio')
      setValue('date_fixed_radio', selectedName === 'date_fixed_radio')
      setValue('date_range_radio', selectedName === 'date_range_radio')
    } else {
      setValue('all_radio', true)
      setValue('date_fixed_radio', false)
      setValue('date_range_radio', false)
    }
  }
  const { data } = useGetAccountGroup()
  return (
    <HeaderLayout>
      <form
        onSubmit={handleSubmit(searchHandler)}
        className={'flex flex-col justify-center gap-4'}
      >
        <SearchHeader
          title={'Thông tin tài khoản'}
          placeholder="Tìm kiếm tên tài khoản, mã sinh viên, email..."
          control={control}
          name={'keywords'}
        />
        <div className="flex items-center justify-between gap-4 text-base font-semibold">
          <Select
            control={control}
            name={'all_radio'}
            title={'Tất cả'}
            onChangeHandler={handleRadioChange}
          />
          <div className="flex items-center">
            <Select
              control={control}
              name={'date_fixed_radio'}
              onChangeHandler={handleRadioChange}
            />
            <Date control={control} name={'date_fixed'} title={'Ngày'} />
          </div>
          <div className="flex items-center">
            <Select
              control={control}
              name={'date_range_radio'}
              onChangeHandler={handleRadioChange}
            />

            <div className="flex items-center gap-3">
              <Date control={control} name={'date_from'} title={'Từ'} />
              <Date control={control} name={'date_to'} title={'Đến'} />
            </div>
          </div>

          <DropDownList
            control={control}
            name={'group'}
            title={'Nhóm tài khoản'}
            options={addDefaultDropDown(
              (data?.groups ?? [])?.map((item) => ({
                value: item?.name,
                label: item?.name,
              }))
            )}
          />
        </div>
      </form>
    </HeaderLayout>
  )
}
